// WCAG 2.x relative-luminance + contrast-ratio utilities.
// Spec: https://www.w3.org/TR/WCAG21/#dfn-contrast-ratio
//
// Thresholds (WCAG 2.1):
//   Normal text  → AA 4.5  · AAA 7.0
//   Large text   → AA 3.0  · AAA 4.5
//   Non-text UI  → 3.0 (informational only)

const HEX_RE = /^#?([0-9a-fA-F]{6})$/;

export function parseHex(hex) {
  const m = HEX_RE.exec((hex || "").trim());
  if (!m) return null;
  const v = m[1];
  return {
    r: parseInt(v.slice(0, 2), 16),
    g: parseInt(v.slice(2, 4), 16),
    b: parseInt(v.slice(4, 6), 16),
  };
}

// sRGB channel → linearised
function lin(c) {
  const s = c / 255;
  return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
}

export function relativeLuminance(rgb) {
  return 0.2126 * lin(rgb.r) + 0.7152 * lin(rgb.g) + 0.0722 * lin(rgb.b);
}

export function contrastRatio(hexA, hexB) {
  const a = parseHex(hexA);
  const b = parseHex(hexB);
  if (!a || !b) return null;
  const La = relativeLuminance(a);
  const Lb = relativeLuminance(b);
  const lighter = Math.max(La, Lb);
  const darker = Math.min(La, Lb);
  return (lighter + 0.05) / (darker + 0.05);
}

export function wcagGrades(ratio) {
  if (ratio == null) return null;
  return {
    ratio,
    aaNormal: ratio >= 4.5,
    aaLarge: ratio >= 3.0,
    aaaNormal: ratio >= 7.0,
    aaaLarge: ratio >= 4.5,
  };
}
